module.exports = __webpack_public_path__ + "img/404.61dc8e2a.png";